var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconErrorFatalRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_8556)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_820_8556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 110C89.3757 110 114 85.3756 114 54.9998C114 24.6243 89.3757 0 59 0C28.6243 0 4 24.6243 4 54.9998C4 85.3756 28.6243 110 59 110Z",
    fill: "#B72640"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.72 106.48C81.1796 106.48 103.44 82.8405 103.44 53.6797C103.44 24.5192 81.1796 0.879883 53.72 0.879883C26.2604 0.879883 4 24.5192 4 53.6797C4 82.8405 26.2604 106.48 53.72 106.48Z",
    fill: "#C4314B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_820_8556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1599 73.3003L42.7201 38.7197",
    stroke: "white",
    strokeWidth: 9.45875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.72 73.3003L76.1598 38.7197",
    stroke: "white",
    strokeWidth: 9.45875,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_820_8556",
    x: 0.48,
    y: 0,
    width: 117.04,
    height: 117.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.52
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_820_8556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_820_8556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_820_8556",
    x: 34.4706,
    y: 33.9903,
    width: 49.9387,
    height: 51.0794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.52
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_820_8556"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_820_8556",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_8556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorFatalRed);
export default __webpack_public_path__ + "static/media/Icon_ErrorFatal_Red.2d09e64cdaad65128bf1fa159aff95f3.svg";
export { ForwardRef as ReactComponent };